<template>
  <div class="teams">
    <div class="content-wrapper">
      <RouterView />
    </div>
  </div>
</template>
